import Vue from 'vue'
import VueRouter from 'vue-router'
import Forgot from '@/components/ForgotPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'forgot',
    component: Forgot
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
